import type { Contact } from '@personical/cc-shared-types';

/**
 * Returns the display name a particular user prefers for this contact:
 * their nickname if set, otherwise the contact's shared displayName.
 */
export function displayNameFor(contact: Contact, userOid: string | null | undefined): string {
  if (userOid && contact.nicknames?.[userOid]) return contact.nicknames[userOid]!;
  return contact.displayName;
}
